interface IPersonSvg {
  width?: string;
  fill?: string;
}
export function PersonSVG({ width = "25", fill = "#136FA3" }: IPersonSvg) {
  return (
    <svg
      className="ctrsSvg"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={width}
      viewBox="0 0 20 20"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_179"
            data-name="Rectangle 179"
            width={width}
            height={width}
            transform="translate(10 13)"
            fill={fill}
          />
        </clipPath>
      </defs>
      <g
        id="Mask_Group_95"
        data-name="Mask Group 95"
        transform="translate(-10 -13)"
        clipPath="url(#clip-path)"
      >
        <g
          id="User_Account_Profile"
          data-name="User , Account , Profile"
          transform="translate(10.001 13)"
        >
          <path
            id="Path_1039"
            data-name="Path 1039"
            d="M260.559,136.085a6.131,6.131,0,1,1,6.131-6.131,6.137,6.137,0,0,1-6.131,6.131m0-10.157a4.026,4.026,0,1,0,4.025,4.026,4.03,4.03,0,0,0-4.025-4.026"
            transform="translate(-250.558 -123.824)"
            fill={fill}
          />
          <path
            id="Path_1040"
            data-name="Path 1040"
            d="M268.537,146.363a1.053,1.053,0,0,1-1.053-1.053,6.692,6.692,0,0,0-6.685-6.685h-2.419a6.692,6.692,0,0,0-6.685,6.685,1.053,1.053,0,1,1-2.105,0,8.8,8.8,0,0,1,8.79-8.79H260.8a8.8,8.8,0,0,1,8.79,8.79,1.053,1.053,0,0,1-1.053,1.053"
            transform="translate(-249.591 -126.363)"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
}

export function TravelSVG({ width = "30", fill = "#0f6aa0" }: IPersonSvg) {
  return (
    <svg
      className="ctrsSvg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={width}
      viewBox="0 0 25 25"
    >
      <g
        id="_064-Suitcase_cart"
        data-name="064-Suitcase cart"
        transform="translate(-2 -2)"
      >
        <path
          id="Path_1302"
          data-name="Path 1302"
          d="M22.773,19.626H6.844a.315.315,0,0,1-.315-.293L5.5,4.518H3.259A1.259,1.259,0,1,1,3.259,2h4.18a.315.315,0,0,1,.315.293L8.783,17.108h13.99a1.259,1.259,0,1,1,0,2.518ZM7.137,19H22.773a.629.629,0,0,0,0-1.259H8.487a.315.315,0,0,1-.315-.293L7.146,2.629H3.259a.629.629,0,0,0,0,1.259H5.793a.315.315,0,0,1,.315.293Z"
          fill={fill}
        />
        <path
          id="Path_1303"
          data-name="Path 1303"
          d="M23.518,61.036a2.518,2.518,0,1,1,2.518-2.518A2.518,2.518,0,0,1,23.518,61.036Zm0-4.406a1.888,1.888,0,1,0,1.888,1.888A1.888,1.888,0,0,0,23.518,56.629Z"
          transform="translate(-13.02 -37.004)"
          fill={fill}
        />
        <path
          id="Path_1304"
          data-name="Path 1304"
          d="M54.518,61.036a2.518,2.518,0,1,1,2.518-2.518A2.518,2.518,0,0,1,54.518,61.036Zm0-4.406a1.888,1.888,0,1,0,1.888,1.888A1.888,1.888,0,0,0,54.518,56.629Z"
          transform="translate(-34.263 -37.004)"
          fill={fill}
        />
        <path
          id="Path_1305"
          data-name="Path 1305"
          d="M38.016,32.813H28.574A1.574,1.574,0,0,1,27,31.239V25.574A1.574,1.574,0,0,1,28.574,24h9.442a1.574,1.574,0,0,1,1.574,1.574v5.665A1.574,1.574,0,0,1,38.016,32.813Zm-9.442-8.183a.944.944,0,0,0-.944.944v5.665a.944.944,0,0,0,.944.944h9.442a.944.944,0,0,0,.944-.944V25.574a.944.944,0,0,0-.944-.944Z"
          transform="translate(-17.131 -15.076)"
          fill={fill}
        />
        <path
          id="Path_1306"
          data-name="Path 1306"
          d="M43.351,19.147H38.315A.315.315,0,0,1,38,18.833V16.944A.944.944,0,0,1,38.944,16h3.777a.944.944,0,0,1,.944.944v1.888A.315.315,0,0,1,43.351,19.147Zm-4.721-.629h4.406V16.944a.315.315,0,0,0-.315-.315H38.944a.315.315,0,0,0-.315.315Z"
          transform="translate(-24.669 -9.594)"
          fill={fill}
        />
        <path
          id="Path_1307"
          data-name="Path 1307"
          d="M32.659,34H30.084a2.2,2.2,0,0,1-1.225-.371l-1.41-.944.346-.522,1.413.944a1.574,1.574,0,0,0,.875.264h2.575Z"
          transform="translate(-17.44 -20.667)"
          fill={fill}
        />
        <path
          id="Path_1308"
          data-name="Path 1308"
          d="M52.575,34H50v-.629h2.575a1.574,1.574,0,0,0,.888-.264l1.413-.944.346.522-1.41.944A2.2,2.2,0,0,1,52.575,34Z"
          transform="translate(-32.892 -20.667)"
          fill={fill}
        />
        <path
          id="Path_1309"
          data-name="Path 1309"
          d="M45.2,35.147H43.315A.315.315,0,0,1,43,34.833V32.315A.315.315,0,0,1,43.315,32H45.2a.315.315,0,0,1,.315.315v2.518A.315.315,0,0,1,45.2,35.147Zm-1.574-.629h1.259V32.629H43.629Z"
          transform="translate(-28.095 -20.558)"
          fill={fill}
        />
      </g>
    </svg>
  );
}
export function LocationSVG({ width = "14", fill = "#0f6aa0" }: IPersonSvg) {
  return (
    <svg
      id="_005-map_location"
      data-name="005-map location"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={(parseInt(width) * 1.351).toString()}
      viewBox="0 0 14.844 20"
    >
      <path
        id="Path_1267"
        data-name="Path 1267"
        d="M7.49,0A7.428,7.428,0,0,0,.07,7.42c0,3.981,6.824,12.095,7.114,12.438a.4.4,0,0,0,.611,0c.291-.343,7.118-8.457,7.118-12.438A7.43,7.43,0,0,0,7.49,0Zm0,18.972C6.151,17.332.87,10.659.87,7.42a6.622,6.622,0,0,1,13.244,0c0,3.238-5.283,9.912-6.624,11.552Zm0,0"
        transform="translate(-0.07)"
        fill={fill}
      />
      <path
        id="Path_1268"
        data-name="Path 1268"
        d="M90.477,86.68a3.736,3.736,0,1,0,3.735,3.734A3.739,3.739,0,0,0,90.477,86.68Zm0,6.649a2.913,2.913,0,1,1,2.911-2.915A2.916,2.916,0,0,1,90.477,93.329Zm0,0"
        transform="translate(-83.057 -82.951)"
        fill={fill}
      />
    </svg>
  );
}

export function MapPinSVG({ width = "15.5", fill = "#0f6aa0" }: IPersonSvg) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={(parseInt(width) * 1.298).toString()}
      viewBox="0 0 15.429 20"
    >
      <g
        id="_076-location"
        data-name="076-location"
        transform="translate(-10 -2)"
      >
        <path
          id="Path_1277"
          data-name="Path 1277"
          d="M21.964,19.667a.284.284,0,0,1-.205-.088,29.068,29.068,0,0,1-2.872-3.7C16.971,12.946,16,10.292,16,7.984a5.964,5.964,0,1,1,11.929,0c0,2.308-.971,4.962-2.887,7.89a29.067,29.067,0,0,1-2.872,3.7.284.284,0,0,1-.205.088Zm0-17.1a5.411,5.411,0,0,0-5.4,5.414c0,4.667,4.386,9.845,5.4,10.976,1.011-1.131,5.4-6.308,5.4-10.976A5.411,5.411,0,0,0,21.964,2.57Z"
          transform="translate(-4.25)"
          fill={fill}
        />
        <path
          id="Path_1278"
          data-name="Path 1278"
          d="M29.208,18.417a3.208,3.208,0,1,1,3.208-3.208A3.208,3.208,0,0,1,29.208,18.417Zm0-5.833a2.625,2.625,0,1,0,2.625,2.625,2.625,2.625,0,0,0-2.625-2.625Z"
          transform="translate(-11.494 -7.083)"
          fill={fill}
        />
        <path
          id="Path_1279"
          data-name="Path 1279"
          d="M25.143,53.583H10.286a.284.284,0,0,1-.229-.117.3.3,0,0,1-.046-.257l2-7a.287.287,0,0,1,.274-.21h2.008v.583H12.5L10.667,53h14.1l-1.833-6.417H21.238V46h1.9a.287.287,0,0,1,.274.21l2,7a.3.3,0,0,1-.046.257A.284.284,0,0,1,25.143,53.583Z"
          transform="translate(0 -31.583)"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export function GlobeSVG({ width = "20", fill = "#0f6aa0" }: IPersonSvg) {
  return (
    <svg
      id="_082-global"
      data-name="082-global"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={width}
      viewBox="0 0 19.974 19.974"
    >
      <path
        id="Path_1280"
        data-name="Path 1280"
        d="M11.987,21.974a9.987,9.987,0,1,1,9.987-9.987,9.987,9.987,0,0,1-9.987,9.987Zm0-19.4A9.416,9.416,0,1,0,21.4,11.987,9.416,9.416,0,0,0,11.987,2.571Z"
        transform="translate(-2 -2)"
        fill={fill}
      />
      <path
        id="Path_1281"
        data-name="Path 1281"
        d="M26.184,54.2a9.416,9.416,0,0,0-13.057,0l-.4-.411a9.987,9.987,0,0,1,13.851,0Z"
        transform="translate(-9.668 -37.017)"
        fill={fill}
      />
      <path
        id="Path_1282"
        data-name="Path 1282"
        d="M19.655,14.982a9.933,9.933,0,0,1-6.925-2.791l.4-.411a9.416,9.416,0,0,0,13.057,0l.4.411A9.933,9.933,0,0,1,19.655,14.982Z"
        transform="translate(-9.668 -8.989)"
        fill={fill}
      />
      <path
        id="Path_1283"
        data-name="Path 1283"
        d="M24.851,21.974c-2.719,0-4.851-4.386-4.851-9.987S22.132,2,24.851,2,29.7,6.386,29.7,11.987,27.57,21.974,24.851,21.974Zm0-19.4c-2.32,0-4.28,4.312-4.28,9.416s1.96,9.416,4.28,9.416,4.28-4.312,4.28-9.416S27.171,2.571,24.851,2.571Z"
        transform="translate(-14.864 -2)"
        fill="#0f6aa0"
      />
      <path
        id="Path_1284"
        data-name="Path 1284"
        d="M36,3h.571V22.4H36Z"
        transform="translate(-26.298 -2.715)"
        fill={fill}
      />
      <path
        id="Path_1285"
        data-name="Path 1285"
        d="M3,36H22.4v.571H3Z"
        transform="translate(-2.715 -26.298)"
        fill={fill}
      />
    </svg>
  );
}
export function CalendarSVG({ width = "22", fill = "#0f6aa0" }: IPersonSvg) {
  return (
    <svg
      id="_022-calendar"
      data-name="022-calendar"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={width}
      viewBox="0 0 22 22"
    >
      <path
        id="Path_1286"
        data-name="Path 1286"
        d="M23.057,38.657H2.943a.972.972,0,0,1-.943-1V22.333A.324.324,0,0,1,2.314,22H23.686a.324.324,0,0,1,.314.333V37.657A.972.972,0,0,1,23.057,38.657ZM2.629,22.666V37.657a.324.324,0,0,0,.314.333H23.057a.324.324,0,0,0,.314-.333V22.666Z"
        transform="translate(-2 -16.657)"
        fill={fill}
      />
      <path
        id="Path_1287"
        data-name="Path 1287"
        d="M23.686,12.275H2.314A.294.294,0,0,1,2,12.007V8.8A.881.881,0,0,1,2.943,8H5.929a.271.271,0,1,1,0,.534H2.943a.294.294,0,0,0-.314.267V11.74H23.371V8.8a.294.294,0,0,0-.314-.267H20.071a.271.271,0,1,1,0-.534h2.986A.881.881,0,0,1,24,8.8v3.206A.294.294,0,0,1,23.686,12.275Z"
        transform="translate(-2 -6.397)"
        fill={fill}
      />
      <path
        id="Path_1288"
        data-name="Path 1288"
        d="M29.515,8.534H21.767a.267.267,0,0,1,0-.534h7.748a.267.267,0,0,1,0,.534Z"
        transform="translate(-14.641 -6.397)"
        fill="#0f6aa0"
      />
      <path
        id="Path_1289"
        data-name="Path 1289"
        d="M52.688,5.74h-1.7a.485.485,0,0,1-.484-.484V2.484A.485.485,0,0,1,50.984,2h1.7a.485.485,0,0,1,.484.484V5.256A.485.485,0,0,1,52.688,5.74Zm-1.653-.534h1.6V2.534h-1.6Z"
        transform="translate(-34.876 -2)"
        fill={fill}
      />
      <path
        id="Path_1290"
        data-name="Path 1290"
        d="M15.688,5.74h-1.7a.485.485,0,0,1-.484-.484V2.484A.485.485,0,0,1,13.984,2h1.7a.485.485,0,0,1,.484.484V5.256A.485.485,0,0,1,15.688,5.74Zm-1.653-.534h1.6V2.534h-1.6Z"
        transform="translate(-9.795 -2)"
        fill={fill}
      />
      <path
        id="Path_1291"
        data-name="Path 1291"
        d="M11.137,31.672h-1.6A.534.534,0,0,1,9,31.137v-1.6A.534.534,0,0,1,9.534,29h1.6a.534.534,0,0,1,.534.534v1.6A.534.534,0,0,1,11.137,31.672Zm-1.6-2.137v1.6h1.6v-1.6Z"
        transform="translate(-7.13 -20.302)"
        fill={fill}
      />
      <path
        id="Path_1292"
        data-name="Path 1292"
        d="M26.47,31.672h-1.6a.534.534,0,0,1-.534-.534v-1.6A.534.534,0,0,1,24.867,29h1.6a.534.534,0,0,1,.534.534v1.6A.534.534,0,0,1,26.47,31.672Zm-1.6-2.137v1.6h1.6v-1.6Z"
        transform="translate(-17.139 -20.302)"
        fill={fill}
      />
      <path
        id="Path_1293"
        data-name="Path 1293"
        d="M41.8,31.672H40.2a.534.534,0,0,1-.534-.534v-1.6A.534.534,0,0,1,40.2,29h1.6a.534.534,0,0,1,.534.534v1.6A.534.534,0,0,1,41.8,31.672Zm-1.6-2.137v1.6h1.6v-1.6Z"
        transform="translate(-27.533 -20.302)"
        fill={fill}
      />
      <path
        id="Path_1294"
        data-name="Path 1294"
        d="M57.137,31.672h-1.6A.534.534,0,0,1,55,31.137v-1.6A.534.534,0,0,1,55.534,29h1.6a.534.534,0,0,1,.534.534v1.6A.534.534,0,0,1,57.137,31.672Zm-1.6-2.137v1.6h1.6v-1.6Z"
        transform="translate(-37.542 -20.302)"
        fill={fill}
      />
      <path
        id="Path_1295"
        data-name="Path 1295"
        d="M11.137,44.672h-1.6A.534.534,0,0,1,9,44.137v-1.6A.534.534,0,0,1,9.534,42h1.6a.534.534,0,0,1,.534.534v1.6A.534.534,0,0,1,11.137,44.672Zm-1.6-2.137v1.6h1.6v-1.6Z"
        transform="translate(-7.13 -29.114)"
        fill={fill}
      />
      <path
        id="Path_1296"
        data-name="Path 1296"
        d="M26.47,44.672h-1.6a.534.534,0,0,1-.534-.534v-1.6A.534.534,0,0,1,24.867,42h1.6a.534.534,0,0,1,.534.534v1.6A.534.534,0,0,1,26.47,44.672Zm-1.6-2.137v1.6h1.6v-1.6Z"
        transform="translate(-17.139 -29.114)"
        fill={fill}
      />
      <path
        id="Path_1297"
        data-name="Path 1297"
        d="M41.8,44.672H40.2a.534.534,0,0,1-.534-.534v-1.6A.534.534,0,0,1,40.2,42h1.6a.534.534,0,0,1,.534.534v1.6A.534.534,0,0,1,41.8,44.672Zm-1.6-2.137v1.6h1.6v-1.6Z"
        transform="translate(-27.533 -29.114)"
        fill={fill}
      />
      <path
        id="Path_1298"
        data-name="Path 1298"
        d="M57.137,44.672h-1.6A.534.534,0,0,1,55,44.137v-1.6A.534.534,0,0,1,55.534,42h1.6a.534.534,0,0,1,.534.534v1.6A.534.534,0,0,1,57.137,44.672Zm-1.6-2.137v1.6h1.6v-1.6Z"
        transform="translate(-37.542 -29.114)"
        fill={fill}
      />
      <path
        id="Path_1299"
        data-name="Path 1299"
        d="M11.137,57.672h-1.6A.534.534,0,0,1,9,57.137v-1.6A.534.534,0,0,1,9.534,55h1.6a.534.534,0,0,1,.534.534v1.6A.534.534,0,0,1,11.137,57.672Zm-1.6-2.137v1.6h1.6v-1.6Z"
        transform="translate(-7.13 -37.542)"
        fill={fill}
      />
      <path
        id="Path_1300"
        data-name="Path 1300"
        d="M26.47,57.672h-1.6a.534.534,0,0,1-.534-.534v-1.6A.534.534,0,0,1,24.867,55h1.6a.534.534,0,0,1,.534.534v1.6A.534.534,0,0,1,26.47,57.672Zm-1.6-2.137v1.6h1.6v-1.6Z"
        transform="translate(-17.139 -37.542)"
        fill={fill}
      />
      <path
        id="Path_1301"
        data-name="Path 1301"
        d="M41.8,57.672H40.2a.534.534,0,0,1-.534-.534v-1.6A.534.534,0,0,1,40.2,55h1.6a.534.534,0,0,1,.534.534v1.6A.534.534,0,0,1,41.8,57.672Zm-1.6-2.137v1.6h1.6v-1.6Z"
        transform="translate(-27.533 -37.542)"
        fill={fill}
      />
    </svg>
  );
}
export function ExtrasSVG({ width = "22", fill = "#0f6aa0" }: IPersonSvg) {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 92 92"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_29)">
        <path
          d="M90.5412 39.7341L83.4021 37.9776C82.4056 33.4696 80.6237 29.2384 78.09 25.3675L81.9634 18.9859C82.4211 18.2317 82.3057 17.2622 81.6817 16.6382L75.4614 10.3991C74.8382 9.77507 73.8703 9.65551 73.1144 10.1108L66.6469 14.012C62.803 11.5471 58.5874 9.8152 54.0859 8.853L52.2664 1.45926C52.0551 0.601883 51.2878 0 50.405 0H41.5946C40.7119 0 39.9454 0.601883 39.7333 1.45926L37.9137 8.853C33.4123 9.8152 29.1975 11.5471 25.3528 14.012L18.886 10.1108C18.1277 9.65306 17.159 9.77425 16.5391 10.3991L10.318 16.6382C9.69482 17.2622 9.57854 18.2317 10.0363 18.9859L13.9096 25.3675C11.3776 29.2376 9.59573 33.4688 8.59915 37.9776L1.45926 39.7341C0.601883 39.9462 0 40.7135 0 41.5963V50.405C0 51.2878 0.601883 52.0551 1.45926 52.2664L8.48123 53.9942C9.42541 58.6504 11.1827 62.9987 13.7164 66.9515L10.0363 73.0145C9.57854 73.7696 9.69482 74.7383 10.318 75.3631L16.5391 81.6014C17.1606 82.2254 18.1286 82.3466 18.886 81.8897L24.8926 78.2661C28.919 80.9332 33.341 82.7814 38.0685 83.7739L39.7333 90.5412C39.9437 91.3978 40.7119 91.9997 41.5946 91.9997H50.405C51.2878 91.9997 52.0551 91.3978 52.2664 90.5412L53.9312 83.7739C58.6594 82.7814 63.0814 80.9332 67.1079 78.2661L73.1144 81.8897C73.8695 82.3458 74.8382 82.2254 75.4614 81.6014L81.6817 75.3631C82.3057 74.7383 82.4211 73.7696 81.9634 73.0145L78.2841 66.9515C80.8185 62.9971 82.5759 58.6496 83.5192 53.9942L90.5412 52.2664C91.3986 52.0551 91.9997 51.2878 91.9997 50.405V41.5963C91.9997 40.7135 91.3986 39.9462 90.5412 39.7341ZM88.1664 48.9032L81.4041 50.5672C80.6621 50.7498 80.0996 51.3549 79.9718 52.1075C79.1251 57.097 77.2621 61.7098 74.4345 65.819C74.007 66.4405 73.9833 67.2545 74.3747 67.9006L77.9066 73.7196L73.8072 77.8304L68.0316 74.3469C67.379 73.9554 66.5543 73.9833 65.9312 74.4255C61.7532 77.3907 57.0773 79.347 52.0305 80.2371C51.2829 80.369 50.6843 80.9291 50.5025 81.6669L48.9032 88.1664H43.0973L41.4988 81.6669C41.317 80.9291 40.7184 80.369 39.9699 80.2371C34.9231 79.347 30.2465 77.3907 26.0685 74.4255C25.4461 73.9833 24.6207 73.953 23.9689 74.3469L18.1924 77.8304L14.0931 73.7196L17.6249 67.9006C18.0164 67.2545 17.9934 66.4405 17.5652 65.819C14.7392 61.7114 12.8754 57.0986 12.0278 52.1075C11.8993 51.3549 11.3375 50.7498 10.5964 50.5672L3.83322 48.9032V43.0981L10.6914 41.4104C11.421 41.231 11.9795 40.6414 12.1179 39.9028C13.0252 35.064 14.9226 30.5634 17.7551 26.5254C18.1924 25.9031 18.2203 25.0809 17.8256 24.4299L14.0931 18.2817L18.1924 14.17L24.4111 17.9214C25.0555 18.3079 25.8687 18.285 26.4869 17.8591C30.4979 15.1003 34.9862 13.2586 39.825 12.3824C40.5694 12.2473 41.1647 11.6888 41.3449 10.9543L43.0973 3.83322H48.9032L50.6548 10.9543C50.8358 11.6888 51.4311 12.2473 52.1747 12.3824C57.0143 13.2586 61.5018 15.1003 65.5127 17.8591C66.1326 18.285 66.9458 18.3079 67.5886 17.9214L73.8072 14.17L77.9066 18.2817L74.1741 24.4299C73.7794 25.0809 73.8072 25.9031 74.2445 26.5254C77.0787 30.565 78.9752 35.0648 79.8834 39.9028C80.0218 40.6414 80.5794 41.231 81.3099 41.4104L88.1664 43.0981V48.9032Z"
          fill="#0F6AA0"
        />
        <path
          d="M46.0002 23.2982C33.3181 23.2982 23.0001 33.6162 23.0001 46.2983C23.0001 58.9804 33.3181 69.2984 46.0002 69.2984C58.6824 69.2984 69.0004 58.9804 69.0004 46.2983C69.0004 33.6162 58.6824 23.2982 46.0002 23.2982ZM46.0002 65.4652C35.4317 65.4652 26.8333 56.8669 26.8333 46.2983C26.8333 35.7297 35.4317 27.1322 46.0002 27.1322C56.5688 27.1322 65.1663 35.7297 65.1663 46.2983C65.1663 56.8669 56.5688 65.4652 46.0002 65.4652Z"
          fill="#0F6AA0"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_29">
          <rect width="92" height="92" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
